import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SmartCartApi } from '@app/core/services/api/smart-cart-api.service';
import { SelectableProduct } from '@app/sharedModule/product-selection/components/add-products-modal/add-products-modal.component';

const DEFAULT_PRODUCT_SEARCH_LIMIT = 50;

@Injectable({ providedIn: 'root' })
export class ProductSearchService {
  constructor(private readonly smartCartApi: SmartCartApi) {}

  searchProducts(query: string): Observable<SelectableProduct[]> {
    const body = { query, limit: DEFAULT_PRODUCT_SEARCH_LIMIT };
    return this.smartCartApi.post('/smart-cart/admin/products/search', body).pipe(
      map((response: { products?: SelectableProduct[] }) =>
        (response?.products ?? []).map((product: any) => {
          const edges = (product.variants?.edges ?? []).filter((edge: any) => edge?.node);
          const firstVariant = edges[0]?.node;
          const firstImage = product.images?.nodes?.[0];

          const optionsMap = new Map<string, Set<string>>();
          edges.forEach(({ node }: any) => {
            node.selectedOptions?.forEach(({ name, value }) => {
              if (!optionsMap.has(name)) optionsMap.set(name, new Set());
              optionsMap.get(name).add(value);
            });
          });
          const options = Array.from(optionsMap.entries()).map(([name, values]) => ({
            name,
            values: Array.from(values),
          }));

          const allPrices = edges.map(({ node }: any) => node.price);
          const hasUniformPrice = allPrices.length <= 1 || allPrices.every((p) => p === allPrices[0]);

          return {
            id: product.id,
            handle: product.handle,
            title: product.title,
            sku: firstVariant?.inventoryItem?.sku || firstVariant?.sku,
            price: firstVariant?.price,
            imageUrl: firstImage?.url,
            options,
            hasUniformPrice,
          };
        }),
      ),
      catchError((err) => {
        console.error('Failed to query products:', err);
        return throwError(err);
      }),
    );
  }
}
